import type { SVGProps } from "react";

export function ChevronExpandIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			role="img"
			aria-label="Expand"
			{...props}
		>
			<path
				d="M4.66699 9.99996L8.00033 13.3333L11.3337 9.99996M4.66699 5.99996L8.00033 2.66663L11.3337 5.99996"
				stroke="#404040"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
